import { SidePanelProps } from '../../types/patient-adherence.types'

const PatientInformationSidePanel = ({ header, data }: SidePanelProps) => {
  return (
    <div className="flex flex-col w-full border-[#EAEAEA] border rounded">
      <div className="p-3  border-s-4 rounded-t border-secondary-450">
        <p className="text-base text-accent-900 px-1 font-primary">{header}</p>{' '}
      </div>
      <div className="flex flex-col border-t border-[#EAEAEA] bg-[#FBFBFB]">
        {data.map((item, index) => (
          <div key={`${item.label}-${item.value}-${index}`} className="p-3 ">
            <p className="text-xs font-extraLight px-2 font-primary">
              {item.label}
            </p>{' '}
            <p className="text-xs font-light px-2 font-primary">{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
export default PatientInformationSidePanel
